export default __webpack_public_path__ + "media/images/home/slide_2024-2025_winter_lg-acad89e28a729157238c7f8be8b2ed69.jpg";